import { Row, Col, Input, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select, DatePicker, notification, Spin } from 'antd';
import { Avatar, Badge } from 'antd';
import { PlusOutlined, DeleteOutlined, MoneyCollectOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, FileImageOutlined, QuestionCircleOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { fetchData, sendData, sendDataDelete, sendDataPut } from '../../httpRequests';
import { ScreenPlans } from './ScreenPlans';
import moment from 'moment';
import axios from 'axios';
// import sha1 from 'sha1'
import { db, firebase } from '../../firebase';
// import CryptoJS from 'crypto-js'
import { collection, query, where, onSnapshot, updateDoc, doc } from 'firebase/firestore';

// import moment from 'moment';

// import {url} from '../../assets/Terminos y Condiciones'


const { Search } = Input;
const { RangePicker } = DatePicker;


const form = {
    name: '',
    website: '',
    category_id: null,
    publicationDate: moment().format('YYYY-MM-DD'),
    terminos: false
}

const planInfo = {
    nameP: "",
    price: 0,
    description: "",
    plan_id: null,
    img: ""
}

const editAds = (
    <div>
        <small> Edit</small>
    </div>
);
const deleteAds = (
    <div>
        <small> Delete</small>
    </div>
);

const activeAds = (
    <div>
        <small>Si desactiva este anuncio no estara disponoble para mostrarse.</small>
    </div>
);
const infoQuestions = (
    <div>
        <small> Preguntas frecuentes sobre el proceso de pago</small>
    </div>
);

const antIcon = <SyncOutlined style={{ fontSize: 50, color: '#128780' }} spin />;

export default function Ads() {
    const [isModalVisibleCreateAds, setIsModalVisibleCreateAds] = useState(false);
    const [formValues, setFormValues] = useState(form)
    const [planInfoSeleted, setPlanInfoSeleted] = useState(planInfo)
    const [categorys, setCategorys] = useState([]);
    const [seeImgInput, setSeeImgInput] = useState(null);
    const [filteredAds, setFilteredAds] = useState([]);
    const [filteredAdsName, setFilteredAdsName] = useState([]);
    const [tbLoading, setTbLoading] = useState(false)
    const [editModo, setEditModo] = useState(true)
    const [planSeleted, setPlanSeleted] = useState(true)
    const [idUpdate, setIdUpdate] = useState(0)
    const [idAds, setIdAds] = useState(0)
    const [validarImg, setValidarImg] = useState(false)
    const [isLoading, setIsLoading] = useState(false);

    const [isModalVisibleHitorial, setIsModalVisibleHitorial] = useState(false);
    const [hitorial, setHitorial] = useState([]);

    const [countHistory, setCountHistory] = useState(0)

    const [visibleDelete, setVisibleDelete] = useState(false)
    const [deleteId, setDeleteId] = useState(0)



    const { website, name, category_id, publicationDate, img, terminos } = formValues
    const { price, nameP, description, plan_id } = planInfoSeleted

    let baseUrl
    baseUrl = (window.location.hostname.includes('localhost'))
        ? `http://localhost:3003/api`
        : `https://coopharma-api-zd5is.ondigitalocean.app/api`



    const PagarPlan = async () => {
        setIsLoading(true)
        const id = localStorage.getItem('PHARMACY_LOGGED')
        const url = `/placeToPay/save/requestId`
        const url1 = '/planAds/create';
        let farmacysInFirebaserequestId = [];
        const ipAdress = await getIpClient();

        const data1 = {
            pharmacy_id: id,
            website,
            name,
            category_id,
            publicationDate: publicationDate != '' ? publicationDate : moment().add(1, 'days').format('YYYY-MM-DD'),
            plan_id,
            idAds
        };

        sendData(url1, data1).then(async (response) => {
            if (response.ok) {
                if (seeImgInput != null && seeImgInput != undefined) {
                    await handleFile(response.ads.id)
                    // revisar porque la img no se esta guardando
                    const data = {
                        pharmacy_id: id,
                        advertisements: true,
                        ipAdress,
                        amount: price,
                        returnUrl: `https://coopharma-83beb.web.app/pharmacy/ads`,
                        type: 'Advertisements',
                        reference: Math.random().toString(36).substring(2),
                        description: description,
                        ads_id: response.ads.id
                    }
                    sendData(url, data).then(async (response) => {
                        if (response.ok) {
                            // buscar registro
                            const getList = await firebase.firestore().collection('RequestId').get()

                            getList.forEach(snapHijo => {
                                farmacysInFirebaserequestId.push({
                                    idfirebase: snapHijo.id,
                                    ...snapHijo.data()
                                })
                            })

                            let verify = farmacysInFirebaserequestId.filter(e => {
                                return e.pharmacy_id == Number(localStorage.getItem('PHARMACY_LOGGED'))
                            })

                            if (verify.length == 0) {
                                const dbRef = await firebase.firestore().collection('RequestId');
                                dbRef.add({ ...data, see: false, requestId: response.data.requestId });
                            } else {
                                await firebase.firestore().doc(`/RequestId/${verify[0].idfirebase}`).delete();

                                const dbRef = await firebase.firestore().collection('RequestId');
                                dbRef.add({ ...data, see: false, requestId: response.data.requestId });
                            }

                            location.replace(response.data.processUrl)
                            setIsLoading(false)
                        } else {

                            setIsLoading(false)
                        }
                    })

                }
                getAds()
                openNotificationWithIcon('success', 'Ads added successfully')
                setIsModalVisibleCreateAds(false)
            } else {
                openNotificationWithIcon('warning', 'Cannot be added.')
            }
            clearData()
        })
    }

    const NuevaPrueba = () => {
        const q = query(collection(db, 'notificationPlaceToPay'), where('pharmacy_id', '==', Number(localStorage.getItem('PHARMACY_LOGGED'))), where('see', '==', false));
        onSnapshot(q, (querySnapshot) => {
            querySnapshot.docChanges().forEach(async (change) => {
                if (change.type === 'added') {
                    // await firebase.firestore().doc(`/notificationPlaceToPay/${change.doc.id}`).update({ see: true });
                    // openNotificationWithIcon('success', 'The payment has been made successfully')
                    searhHistory()
                    getAds()
                }
            });
            // openNotificationWithIcon('success', 'The payment has been made successfully')

        })
    }

    const consultSession = async () => {
        let farmacysInFirebaserequestId = [];

        const getList = await firebase.firestore().collection('RequestId').get()

        getList.forEach(snapHijo => {
            farmacysInFirebaserequestId.push({
                idfirebase: snapHijo.id,
                ...snapHijo.data()
            })
        })

        if (farmacysInFirebaserequestId.length != 0) {

            let verify = farmacysInFirebaserequestId.filter(e => {
                return e.pharmacy_id == Number(localStorage.getItem('PHARMACY_LOGGED'))
            })
            const url = `${baseUrl}/placeToPay/consultSession/${verify[0].requestId}`

            if (verify[0].see == false) {

                const { see, ...datos } = verify[0]
                // console.log("hacer peticion con requestid y actulizarlo true", )
                // await firebase.firestore().doc(`/RequestId/${verify[0].idfirebase}`).update({ ...datos, see: false });

                await axios.get(url).then(async (res) => {
                    if (res.data.ok) {
                        console.log(res.data)
                        await firebase.firestore().doc(`/RequestId/${verify[0].idfirebase}`).update({ ...datos, see: true });

                        const data = {
                            paymentStatus: res.data.respon.status.status,
                            reference: res.data.respon.request.payment.reference

                        }

                        await axios.put(`${baseUrl}/placeToPay/updateStatusAds/${verify[0].requestId}`, data).then(async (res) => {
                            if (res.data.ok) {
                                getAds()
                            }
                        })
                    }
                }).catch(error => {
                    console.log(error)
                })

            }
        }

    }

    const getCategoty = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                setCategorys(categories)
            }
        })
    }
    const getAds = () => {
        const id = localStorage.getItem('PHARMACY_LOGGED')
        setTbLoading(true)
        const url = `/planAds/getPlanAds/${id}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const planAds = response['planAds'];
                setFilteredAds(planAds)
                setFilteredAdsName(planAds)
                setTbLoading(false)
                setIsModalVisibleCreateAds(false)
            }
        })
    }

    useEffect(() => {
        consultSession()
        getCategoty()
        getAds()
        NuevaPrueba()
    }, [])

    const handleFilter = (e) => {
        setFormValues({
            ...formValues,
            category_id: e
        })
    }

    //open modal 
    const showModalCreateAds = () => {
        setIsModalVisibleCreateAds(true)
        setEditModo(true)
    }

    // close modal
    const handleCancel = () => {
        setIsModalVisibleHitorial(false)
        setIsModalVisibleCreateAds(false)
        setVisibleDelete(false)
        setSeeImgInput(null)
        setFormValues({
            ...formValues,
            name: '',
            website: '',
            category_id: null,
            publicationDate: moment().format('YYYY-MM-DD'),
            img: ''
        });

        const planInfo = {
            nameP: "",
            price: 0,
            description: "",
            plan_id: null,
            img: ""
        }
        setPlanInfoSeleted(planInfo)
        setIdUpdate(0)
        setIdAds(0)
    }

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }
    useEffect(() => {
        if (seeImgInput != null) {
            seeFileProduct()
        }
    }, [seeImgInput])

    const seeFileProduct = async () => {
        if (seeImgInput.target.files[0] != undefined) {
            const image = document.getElementById("image-selected1");
            const image2 = document.getElementById("image-selected");
            const reader = new FileReader();
            reader.readAsDataURL(seeImgInput.target.files[0]);

            reader.onload = (seeImgInput) => {
                console.log(seeImgInput, "lklklk")
                seeImgInput.preventDefault();
                image.setAttribute('src', seeImgInput.target.result)
                image2.setAttribute('src', seeImgInput.target.result)
                image.removeAttribute("width")
                image.removeAttribute("height")

                image.onload = () => {
                    var ancho = image.width;
                    var alto = image.height
                    if (ancho != 900 || alto != 500) {
                        console.log('no cumple')
                        setValidarImg(true)
                    } else {
                        setValidarImg(false)
                    }
                    console.log(ancho == 900)
                    console.log(ancho + ' ' + alto, 'ajajajaj');

                }
            }

        } else {
            setSeeImgInput(null)
        }
    }
    const selectedPlan = (event) => {
        const data = {
            nameP: event.name,
            price: event.price,
            description: event.description,
            plan_id: event.id
        }
        setPlanInfoSeleted(data)
    }

    const saveAds = async () => {
        let farmacysInFirebaserequestId = [];
        const ipAdress = await getIpClient();
        const id = localStorage.getItem('PHARMACY_LOGGED')
        const url = '/planAds/create';
        const url2 = `/planAds/updatePlanAds/${idUpdate}`
        const url3 = `/placeToPay/update/${idAds}`
        const data = {
            pharmacy_id: id,
            website,
            name,
            category_id,
            publicationDate: publicationDate != '' ? publicationDate : moment().add(1, 'days').format('YYYY-MM-DD'),
            plan_id,
            idAds
        };

        const data2 = {
            ipAdress,
            returnUrl: `https://coopharma-83beb.web.app/pharmacy/ads`,
        }

        if (editModo) {
            sendData(url, data).then(async (response) => {
                if (response.ok) {
                    if (seeImgInput != null && seeImgInput != undefined) {
                        await handleFile(response.ads.id)
                        setIdAds(response.ads.id)

                    }
                    getAds()
                    openNotificationWithIcon('success', 'Ads added successfully')
                    setIsModalVisibleCreateAds(false)
                } else {
                    openNotificationWithIcon('warning', 'Cannot be added.')
                }
                clearData()
            })

        } else {
            sendDataPut(url2, data).then(async (response) => {

                if (response.ok) {
                    if (seeImgInput != null && seeImgInput != undefined) {
                        await handleFile(response.ads.id)
                    }
                    sendDataPut(url3, data2).then(async (r) => {
                        console.log(r.result)
                        const { ...datos } = r.result
                        if (r.ok) {
                            // buscar registro
                            const getList = await firebase.firestore().collection('RequestId').get()

                            getList.forEach(snapHijo => {
                                farmacysInFirebaserequestId.push({
                                    idfirebase: snapHijo.id,
                                    ...snapHijo.data()
                                })
                            })
                            let verify = farmacysInFirebaserequestId.filter(e => {
                                return Number(e.pharmacy_id) == Number(localStorage.getItem('PHARMACY_LOGGED'))
                            })
                            if (verify.length == 0) {
                                const dbRef = await firebase.firestore().collection('RequestId');
                                // await firebase.firestore().doc(`/RequestId/${verify[0].idfirebase}`).update({  see: false });
                                dbRef.add({ ...datos, see: false });
                            } else {
                                await firebase.firestore().doc(`/RequestId/${verify[0].idfirebase}`).delete();
                                const dbRef = await firebase.firestore().collection('RequestId');
                                dbRef.add({ ...datos, see: false });
                            }

                            // location.replace(r.data.processUrl)
                            setIsLoading(false)
                        } else {
                            setIsLoading(false)
                        }
                    })

                    getAds()
                    openNotificationWithIcon('success', response.msg)
                    setIsModalVisibleCreateAds(false)
                } else {
                    openNotificationWithIcon('warning', response.msg)
                }
                clearData()
            })

        }
    }

    const showModalEditar = async (id, name_ads, website, category_id, fecha, img, plans_name, ads_id) => {
        setIdUpdate(id)
        setIdAds(ads_id)
        setFormValues({
            ...formValues,
            name: name_ads,
            website: website,
            category_id: category_id,
            publicationDate: (fecha != null) ? moment(fecha).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            img
        });
        if (plans_name) {
            setPlanSeleted(true)
        } else {
            setPlanSeleted(false)
        }

        setEditModo(false)
        setIsModalVisibleCreateAds(true)

    }

    const handleFile = async (id) => {
        let cloudurl = (window.location.hostname.includes('localhost'))
            ? `http://localhost:3003/api/advertisements/updatePhotoAds/ads/${id}`
            : `https://coopharma-api-zd5is.ondigitalocean.app/api/advertisements/updatePhotoAds/ads/${id}`

        let file = seeImgInput.target.files[0]
        const formData = new FormData();
        formData.append('image', file);
        try {
            const resp = await fetch(cloudurl, {
                method: 'post',
                body: formData
            });

            if (resp.ok) {
                const cloudResp = await resp.json();
                setSeeImgInput(null)
            }
        } catch (error) {
            console.log(error, "error")
        }
    }
    const columns = [
        {
            title: 'REFERENCE',
            render: ({ reference }) => (
                <div>
                    {reference}
                </div>
            )
        },
        {
            title: 'NAME',
            render: ({ name_ads }) => (
                <div>
                    {name_ads}
                </div>
            )
        },
        {
            title: 'IMG',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img} />
                </div>
            )
        },
        {
            title: 'SITIO WEB',
            render: ({ website }) => (
                <div>
                    <a href={website}>{website}</a>
                </div>
            )
        },

        {
            title: 'CATEGORY',
            dataIndex: 'name_category',
            key: 'name_category',
        },
        {
            title: 'PLAN',
            render: ({ plans_name }) => (
                <div>
                    {
                        (plans_name == null)
                            ? <div style={{ color: 'red' }}>
                                No seleted
                            </div>
                            : <div>
                                {plans_name}
                            </div>
                    }
                </div>
            )
        },
        {
            title: 'PUBLICATION DATE',
            render: ({ publicationDate }) => (
                <div>
                    {
                        (publicationDate) ? <div> {moment(publicationDate)
                            .format("LLLL")
                        }</div> : <div style={{ color: 'red' }}>No seleted</div>
                    }

                </div>
            )
        },

        {
            title: 'PUBLICATION END DATE',
            render: ({ lastPublicationDate }) => (
                <div>
                    {
                        (lastPublicationDate) ? <div> {moment(lastPublicationDate)
                            .format("LLLL")
                        }</div> : <div style={{ color: 'red' }}>No seleted</div>
                    }

                </div>
            )
        },
        {
            title: 'PAYMENT',
            // dataIndex: 'paymentStatus',
            render: ({ paymentStatus }) => (
                <div>
                    {
                        (paymentStatus != null)
                            ?
                            <div>{paymentStatus}</div>
                            : <div color="volcano" >PENDING</div>
                    }
                </div>
            )
            // key: 'paymentStatus',
        },

        {
            title: 'STATUS',
            render: ({ paymentStatus }) => (
                <div>
                    {
                        (paymentStatus == 'APPROVED')
                            ?
                            // <Popover content={activeAds} trigger="hover">
                            <Tag color="green">Active</Tag>
                            // </Popover>
                            : <Tag color="volcano" >Disabled</Tag>
                    }
                </div>
            )
        },

        {
            title: 'ACTION',
            render: ({ id, img, name_ads, website, category_id, publicationDate, plans_name, ads_id, paymentStatus }) => (

                <div>
                    {(paymentStatus != 'APPROVED')
                        ?
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Popover content={editAds} trigger="hover">
                                <Button onClick={() => showModalEditar(id, name_ads, website, category_id, publicationDate, img, plans_name, ads_id)}>

                                    {/* <span style={{ margin: 10, cursor: 'pointer' }}> */}
                                    <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
                                    {/* </span> */}

                                </Button>
                            </Popover>
                            <Popover content={deleteAds} trigger="hover">
                                <Button onClick={() => showModalDelete(id, name_ads, website, category_id, publicationDate, img, plans_name, ads_id)}>

                                    {/* <span style={{ margin: 10, cursor: 'pointer' }}> */}
                                    <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
                                    {/* </span> */}

                                </Button>
                            </Popover>

                        </div>


                        : <div style={{ display: 'flex' }} >
                            <Popover content={editAds} trigger="hover">
                                <Button onClick={() => showModalEditar(id, name_ads, website, category_id, publicationDate, img, plans_name, ads_id)} disabled>

                                    {/* <span style={{ margin: 10, cursor: 'pointer' }}> */}
                                    <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
                                    {/* </span> */}

                                </Button>
                            </Popover>
                            <Popover content={deleteAds} trigger="hover">
                                <Button onClick={() => showModalEditar(id, name_ads, website, category_id, publicationDate, img, plans_name, ads_id)} disabled>

                                    {/* <span style={{ margin: 10, cursor: 'pointer' }}> */}
                                    <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
                                    {/* </span> */}

                                </Button>
                            </Popover>

                        </div>
                    }
                </div>

            )
        },

    ]

    const showModalDelete = (id) => {
        setDeleteId(id)
        setVisibleDelete(true)
    }
    const deleteAd = async () => {
        const url = `/advertisements/ads/${deleteId}`;
        sendDataDelete(url).then((response) => {
            if (Object.keys(response).length > 0) {
                if (response.ok) {
                    setVisibleDelete(false)
                    openNotificationWithIcon('success', 'ad removed successfully')
                    getAds()
                }
            }
        })

    }
    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje,
            icon: ''

        });
    };

    const handleInputChangeFecha = (date, dateString) => {
        setFormValues({
            ...formValues,
            publicationDate: dateString
        });
    };
    const onSearch = (value) => {
        let text = value.target.value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
        if (text) {
            // let newText = String(text)
            const filteredAdsName = filteredAds.filter((ads) => {
                return ads.name_ads.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().includes(text)
            });
            setFilteredAdsName(filteredAdsName);
        } else {
            setFilteredAdsName(filteredAds);
        }
    }
    const clearData = () => {
        const form = {
            name: '',
            website: '',
            category_id: null,
            publicationDate: moment().format('YYYY-MM-DD')
        }
        setFormValues(form)

        const planInfo = {
            nameP: "",
            price: 0,
            description: "",
            plan_id: null,
            img: ""
        }
        setPlanInfoSeleted(planInfo)
    }
    async function getIpClient() {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            return response.data.ip
        } catch (error) {
            console.error(error);
        }
    }

    const showModalHitorial = () => {
        searhHistory()
        setIsModalVisibleHitorial(true)
    }

    const searhHistory = async () => {
        let farmacysHitorial = [];
        const getList = await firebase.firestore().collection('notificationPlaceToPay').get()
        getList.forEach(snapHijo => {
            farmacysHitorial.push({
                idfirebase: snapHijo.id,
                ...snapHijo.data()
            })
        })
        let verify = farmacysHitorial.filter(e => {
            return e.pharmacy_id == Number(localStorage.getItem('PHARMACY_LOGGED'))
        })
        let a = verify.sort((a, b) => Number(a.see) - Number(b.see))

        let count = verify.filter(e => {

            return e.see == false
        })

        setCountHistory(count.length)
        setHitorial(a)
    }

    const seeHistory = async (data) => {
        await firebase.firestore().doc(`/notificationPlaceToPay/${data.idfirebase}`).update({ see: true });
        searhHistory()

    }

    const handleInputChangeCheckbox = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.checked
        });

    }

    const Terms = () => {
        window.open('https://coopharma-83beb.web.app/termsandconditions')
    }

    const questions = () => {
        window.open('https://coopharma-83beb.web.app/frequentquestions')
    }

    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={14}>
                    <Search
                        size='large'
                        placeholder='Search name'
                        onChange={onSearch}
                    />
                </Col>
                <Col span={6}>
                    <Button
                        onClick={showModalCreateAds}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        {/* <PlusOutlined /> */}
                        Create Ads
                    </Button>
                </Col>
                <Col span={2}>
                    <Badge size="default" count={countHistory}>
                        <Button
                            onClick={showModalHitorial}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                        >
                            {/* <PlusOutlined /> */}
                            Historial
                        </Button>
                    </Badge>
                </Col>
                <Col span={2}>
                    <div style={{ textAlign: 'right', fontSize: '23px', cursor: 'pointer' }}>
                        <Popover content={infoQuestions} trigger="hover">
                            <QuestionCircleOutlined onClick={questions} />
                        </Popover>

                    </div>
                </Col>
            </Row>
            <Modal title={editModo ? "Add Ads" : "Edit ads"}
                visible={isModalVisibleCreateAds}
                onCancel={handleCancel}
                width={700}
                footer={null}
                closable={true}
            >
                {isLoading == true ? (<div className='adsP'>
                    <Spin tip="Please Wait This may take a while...." indicator={antIcon}>
                    </Spin>
                </div>) : (<></>)}
                <div><b style={{ color: 'red' }}>*</b> Campos obligatorios</div>

                <Row gutter={24}>
                    <Col span={24} className='formMarginInput'>
                        <Form>
                            <Row gutter={24}>
                                <Col span={24}>

                                    <label htmlFor="" ><b style={{ color: 'red' }}>*</b> <b>Select Image</b></label>
                                    <div className='bordereFile' style={{ marginTop: "10px" }}>
                                        <div className='file-select'>
                                            <div className='drag'>
                                                <div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <FileImageOutlined style={{ fontSize: '32px', color: 'white' }} />
                                                    </div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <b style={{ fornSize: '17px', color: 'white' }}>Add Image</b>
                                                    </div>
                                                    <p style={{ color: 'white' }}>or drag and drop</p>
                                                </div>
                                            </div>
                                            <input type="file" onChange={(e) => setSeeImgInput(e)} accept="jpeg" />
                                        </div>

                                    </div>
                                    <b> La imagen tiene que tener una dimensión de 900 * 500</b>

                                </Col>
                                <Col span={24} style={{ display: 'none' }}>
                                    <img src="" alt="" id="image-selected1" style={{ marginTop: "10px", borderRadius: 20 }} />
                                </Col>
                                <Col span={24} >
                                    {(validarImg) ? <small style={{ color: 'red' }}>Esta Imagen no cumple con la dimensión requerida</small> : <small></small>}
                                    {(seeImgInput != null) ? <img src={img} height='180' width="60%" alt="" id="image-selected" style={{ marginTop: "10px", borderRadius: 20 }} /> : <div></div>}
                                </Col>
                                <Col span={24} >
                                    {(editModo == false && seeImgInput == null) ? <img src={img} height='180' width="60%" alt="" id="image-selected" style={{ marginTop: "10px", borderRadius: 20 }} /> : <div></div>}
                                </Col>
                                <Col span={12} className='formMarginInput'>
                                    <label htmlFor=""><b style={{ color: 'red' }}>*</b> <b>Name</b></label>
                                    <Input
                                        type='text'
                                        size='large'
                                        name="name"
                                        value={name}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col span={12} className='formMarginInput'>
                                    <label htmlFor=""><b style={{ color: 'red' }}>*</b> <b>Category</b></label>
                                    <Select style={{ width: '100%' }} size='large' name="category_id" value={category_id} onChange={handleFilter}>
                                        {categorys.map((c) => (
                                            <Select.Option key={c.id} value={c.id}  >
                                                {c.name}
                                            </Select.Option>
                                        ))
                                        }
                                    </Select>
                                </Col>
                                <Col span={12} className='formMarginInput'>
                                    <label htmlFor=""><b>Website</b></label>
                                    <Input
                                        type='url'
                                        size='large'
                                        name="website"
                                        value={website}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                {/* create */}
                                {(editModo == true) ? <Col span={12} className='formMarginInput'>
                                    <label htmlFor=""> <b>Publication date </b></label>
                                    <DatePicker style={{ width: '100%' }} size='large' onChange={handleInputChangeFecha} value={moment(publicationDate)} defaultValue={moment(publicationDate)} allowClear={false} />
                                </Col> : <div></div>}
                                {/* edit */}
                                {(editModo == false && planSeleted == false) ? <Col span={12} className='formMarginInput'>
                                    <label htmlFor=""> <b>Publication date </b></label>
                                    <DatePicker style={{ width: '100%' }} size='large' onChange={handleInputChangeFecha} value={moment(publicationDate)} defaultValue={moment(publicationDate)} allowClear={false} />
                                </Col> : <div></div>}

                                {/* create */}
                                {(editModo == true) ? <Col span={5} style={{ marginTop: '20px' }}>
                                    <ScreenPlans form={formValues} selectedPlan={selectedPlan} />
                                    {(nameP == '') ? <small style={{ color: 'red' }}><b>No plan selected</b> </small> : <div></div>}
                                </Col> : <div></div>}
                                {(editModo == true) ? <Col span={24}>
                                    <Row gutter={24}>
                                        <Col span={12} style={{ marginTop: 5 }}>
                                            <label htmlFor=""><b style={{ fontSize: 15 }}>Plan name: </b>{nameP}</label>
                                        </Col>
                                        <Col span={12} >
                                            <label htmlFor=""><b style={{ fontSize: 15 }}>Plan price: </b><b style={{ color: 'green' }}>$</b>{price}</label>
                                        </Col>
                                        <Col span={24} >
                                            <label htmlFor=""><b style={{ fontSize: 15 }}>Description: </b>{description}</label>
                                        </Col>

                                    </Row>

                                </Col> : <div></div>}

                                {/* edit */}
                                {(editModo == false && planSeleted == false) ? <Col span={5} style={{ marginTop: '20px' }}>
                                    <ScreenPlans form={formValues} selectedPlan={selectedPlan} />
                                    {(nameP == '') ? <small style={{ color: 'red' }}><b>No plan selected</b> </small> : <div></div>}
                                </Col> : <div></div>}

                                {(editModo == false && planSeleted == false) ? <Col span={24}>
                                    <Row gutter={24}>
                                        <Col span={12} style={{ marginTop: 5 }}>
                                            <label htmlFor=""><b style={{ fontSize: 15 }}>Plan name: </b>{nameP}</label>
                                        </Col>
                                        <Col span={12} >
                                            <label htmlFor=""><b style={{ fontSize: 15 }}>Plan price: </b><b style={{ color: 'green' }}>$</b>{price}</label>
                                        </Col>
                                        <Col span={24} >
                                            <label htmlFor=""><b style={{ fontSize: 15 }}>Description: </b>{description}</label>
                                        </Col>

                                    </Row>

                                </Col> : <div></div>}


                                {(editModo == true) ? <Col span={24}>
                                    {/* <Button
                                        htmlType="submit"
                                        onClick={saveAds}
                                        type='primary'
                                        size='large'
                                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: 10 }}
                                        disabled={seeImgInput == null || name == '' || validarImg == true}
                                    >
                                        <SaveOutlined />
                                        Save
                                    </Button> */}
                                    <Col span={24} className='formMarginInput' style={{ textAlign: 'center' }}>
                                        <Row gutter={24}>
                                            <Col span={24}>

                                                <Checkbox
                                                    color='green'
                                                    size='large'
                                                    name="terminos"
                                                    checked={terminos}
                                                    onChange={handleInputChangeCheckbox}

                                                />
                                                <label htmlFor="" style={{ cursor: 'pointer' }}>  <a href="" onClick={Terms}>Accept terms and conditions. </a></label>
                                                {/* <a href="#" onClick=window.open('MyPDF.pdf', '_blank', 'fullscreen=yes'); return false;">MyPDF</a> */}
                                            </Col>

                                        </Row>
                                    </Col>

                                    <Button
                                        htmlType="submit"
                                        onClick={PagarPlan}
                                        type='primary'
                                        size='large'
                                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: 10 }}
                                        disabled={nameP == '' || seeImgInput == null || name == '' || isLoading == true || validarImg == true || terminos == false}

                                    >
                                        <MoneyCollectOutlined />
                                        Pay and save
                                    </Button>
                                </Col> : <div></div>}

                                {(editModo == false) ? <Col span={24}>
                                    <Button
                                        htmlType="submit"
                                        onClick={saveAds}
                                        type='primary'
                                        size='large'
                                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: 10 }}
                                        disabled={name == '' || validarImg == true}
                                    >
                                        <MoneyCollectOutlined />
                                        Pay and save
                                    </Button>
                                </Col> : <div></div>}
                            </Row>

                            {/* <Col span={24} className='formMarginInput'>
                                <label htmlFor=""><span style={{ color: 'red' }}>*</span>Image </label>

                                
                            </Col> */}
                        </Form>

                    </Col>
                </Row>
            </Modal>
            <Modal title='Hitorial'
                onCancel={handleCancel}
                visible={isModalVisibleHitorial}
                width={700}
                footer={null}
                closable={true}
            >
                <div style={{ height: '700px', overflowY: 'scroll', padding: '10px' }} >
                    {hitorial.map((h) => (
                        <div key={h.idfirebase} style={{ cursor: 'pointer', padding: '10px' }} className='historial' onClick={() => seeHistory(h)}>
                            <div style={{ textAlign: 'right', fontSize: '10px' }}>
                                <b> {moment(h.date).format('LLLL')}</b>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                    <div>
                                        <b> Reference: </b>{h.reference}
                                    </div>
                                    <div>
                                        <b>Payment:</b> {h.paymentStatus}
                                    </div>
                                    <div>
                                        <b> Type: </b>Advertisements
                                    </div>
                                    <div>
                                        <b> Description: </b>{h.description}
                                    </div>

                                    <div>
                                        <b> Amount: </b><b style={{ color: 'green' }}>$</b><b>{h.amount}</b>
                                    </div>
                                </div>

                                {(h.see == true) ? <div>
                                    <b>
                                        <EyeOutlined style={{ color: 'green', fontSize: '17px' }} />
                                    </b>
                                </div> :
                                    <div>
                                        <b>
                                            <EyeInvisibleOutlined style={{ color: 'red', fontSize: '17px' }} />
                                        </b>
                                    </div>}
                            </div>
                            {/* <div>
                            <EyeInvisibleOutlined />
                        </div> */}
                        </div>
                    ))}
                </div>


            </Modal>
            <Modal title='Delete'
                onCancel={handleCancel}
                width={400}
                footer={null}
                closable={true}
                visible={visibleDelete}
            >

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <DeleteOutlined style={{ fontSize: '75px', color: 'red' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', fontSize: '17px' }}>
                    <p>Are you sure you want to remove this <b>ad?</b></p>
                </div>

                <div>
                    <Button
                        htmlType="submit"
                        onClick={deleteAd}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: 10 }}
                        disabled={deleteId == 0}

                    >
                        <SaveOutlined />
                        Delete
                    </Button>
                </div>

            </Modal>
            <Table columns={columns} dataSource={filteredAdsName} rowKey={(item) => item.id}
                loading={tbLoading} />

        </div>
    )

    // filteredAds
}